<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot-scope="scope" slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            plain
            @click.stop="handleSetTags(scope.row,scope.index)"
          >批量打标签</el-button>
          <!-- <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >批量删除</el-button>-->
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <!-- <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >删除</el-button>-->
        </template>
        <template slot="search">
          <el-form-item label="用户类型" size="small" style="margin-top: 4px">
            <el-col :md="32">
              <el-select
                v-model="currclientType"
                clearable
                placeholder="请选择用户类型"
                @change="changeSendType"
              >
                <el-option
                  v-for="item in clientTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="分组标签" size="small" style="margin-top: 4px">
            <el-col :md="32">
              <el-select v-model="searchClassify" clearable multiple placeholder="请选择标签">
                <el-option
                  v-for="item in classifySelects"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </template>
        <template slot-scope="scope" slot="labelNameForm">
          <el-select v-model="currClassify" clearable multiple placeholder="请选择标签">
            <el-option
              v-for="item in classifySelects"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="shopInfoForm">
          <el-input v-model="shopName" disabled placeholder="请输入内容"></el-input>
        </template>
        <template slot-scope="scope" slot="engineerInfoForm">
          <el-input v-model="engineerInfo" disabled placeholder="请输入内容"></el-input>
        </template>
        <template slot-scope="scope" slot="promotionInfoForm">
          <el-input v-model="promotionInfo" disabled placeholder="请输入内容"></el-input>
        </template>
        <template slot-scope="scope" slot="labelName">
          <span>{{scope.row.labelName?(scope.row.labelName.length>13)?scope.row.labelName.slice(0,13)+'..':scope.row.labelName:''}}</span>
          <a
            href="#"
            @click="openMore(scope.row)"
            v-if="scope.row.labelName?(scope.row.labelName.length>13):false"
            style="text-decoration: underline;color:rgb(48, 133, 230)"
          >{{moreTemplate}}</a>
        </template>
      </avue-crud>

      <el-dialog title="批量打标签" :visible.sync="dialogSetTags" width="30%">
        <span>选择标签:</span>
        <el-select v-model="currClassify" clearable multiple placeholder="请选择标签">
          <el-option
            v-for="item in classifySelects"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateSetTags">保 存</el-button>
          <el-button @click="dialogSetTags = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog title="标签" :visible.sync="moreDialog" width="40%">
        <el-form :model="redpacketform">
          <el-form-item label="工程师" :label-width="formLabelWidth">
            <el-input disabled v-model="redpacketform.username"></el-input>
          </el-form-item>
          <el-form-item label="分组标签" :label-width="formLabelWidth">
            <el-select v-model="redpacketform.labelIds" clearable disabled multiple placeholder="请选择标签">
              <el-option
                v-for="item in classifySelects"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <span>分组标签:</span> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="moreDialog = false">取 消</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { setTagsOption } from "@/const/salesCloud/setTagsOption";
import {
  findTags,
  findLabelList,
  findTagslList,
  editTags
} from "@/api/salesCloud/setTags";
import { DIC } from "@/const/dic";

export default {
  name: "tags",
  data() {
    return {
      tableOption: setTagsOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      dialogSetTags: false,
      moreDialog: false,
      loading: false,
      formLabelWidth: "120px",
      classifySelects: [],
      clientType: "",
      currclientType: "",
      clientTypes: DIC.TAGS_CLIENT_TYPE,
      currClassify: [],
      searchClassify: [],
      tabelObj: {},
      isType: false,
      redpacketform: {},
      ids: "",
      moreTemplate: "更多",
      shopName: "",
      engineerInfo: "",
      promotionInfo:"",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {},
  props: [],
  methods: {
    openMore(row) {
      console.log(row);
      this.redpacketform = {};
      let params = {
        clientType: row.clientType
      };
      findLabelList(params).then(res => {
        console.log(res);
        let data = JSON.parse(res.data);
        console.log(data);
        this.totalPeople = data.all;
        data = data.list.map(item => {
          item.name = item.name + "(" + item.count + ")";
          return item;
        });
        this.classifySelects = data;
      });
      this.redpacketform.username =row.username
      this.redpacketform.labelIds =row.labelIds.split(',')
      this.moreDialog = true;
    },
    changeSendType() {
      this.currClassify = [];
      // this.redpacketform = {};
      let params = {
        clientType: this.currclientType
      };
      findLabelList(params).then(res => {
        console.log(res);
        let data = JSON.parse(res.data);
        console.log(data);
        this.totalPeople = data.all;
        data = data.list.map(item => {
          item.name = item.name + "(" + item.count + ")";
          return item;
        });
        this.classifySelects = data;
      });
    },
    handleSetTags() {
      this.clean();
      console.log(this.isType);
      if (this.isType) {
        this.dialogSetTags = true;
        let params = {
          clientType: this.clientType
        };
        findLabelList(params).then(res => {
          console.log(res);
          let data = JSON.parse(res.data);
          this.classifySelects = data.list;
        });
      } else {
        this.$message({
          showClose: true,
          message: "请选择正确的用户类型",
          type: "error"
        });
      }
    },
    remoteMethod(query) {
      console.log(query.length);
      if (query.length == 11) {
        // this.loading = true;
        setTimeout(() => {
          //   this.loading = false;
          console.log("远程搜索");
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findLabelList(params).then(res => {
            console.log(res);
            let data = JSON.parse(res.data);
            this.classifySelects = data;
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },
    clean() {
      this.currClassify = [];
      this.classifySelects = [];
      setTagsOption.column[1].editVisdiplay = false;
      setTagsOption.column[2].editVisdiplay = false;
        setTagsOption.column[3].editVisdiplay = false;
    },
    searchClear() {
      this.currclientType = "";
      this.searchClassify = [];
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findTags(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findTags(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.labels = this.searchClassify.join(",");
      params.clientType = this.currclientType;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;

      console.log(params);
      findTags(params).then(res => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      console.log(page);
      findTags(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      this.clean();
      if (row.clientType == "JOINS_ENGINEER") {
        console.log(row);
        setTagsOption.column[2].editVisdiplay = true;
        console.log("JOINS_ENGINEER");
        this.engineerInfo = row.username + "(" + row.mobile + ")";
        let params = {
          clientType: row.clientType
        };
        findLabelList(params).then(res => {
          console.log(res);
          let data = JSON.parse(res.data);
          this.classifySelects = data.list;
        });
      } else if (row.clientType == "JOINS_MERCHANT") {
        console.log(row);
        setTagsOption.column[1].editVisdiplay = true;
        this.shopName = row.username + "(" + row.shopName + ")";
        console.log("JOINS_MERCHANT");
        let params = {
          clientType: row.clientType
        };
        findLabelList(params).then(res => {
          console.log(res);
          let data = JSON.parse(res.data);
          this.classifySelects = data.list;
        });
      }else if (row.clientType == "JOINS_PROMOTION_SPECIALIST") {
        console.log(row);
        setTagsOption.column[3].editVisdiplay = true;
        this.promotionInfo = row.username + "(" + row.mobile + ")";
        console.log("JOINS_PROMOTION_SPECIALIST");
        let params = {
          clientType: row.clientType
        };
        findLabelList(params).then(res => {
          console.log(res);
          let data = JSON.parse(res.data);
          this.classifySelects = data.list;
        });
      }
      if (row.labelIds) {
        this.currClassify = row.labelIds.split(",");
      }
      this.$refs.crud.rowEdit(row, index);
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findTags(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(row);
      addTags(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      console.log(val);
      let types = val.map(item => {
        return item.clientType;
      });
      let length = Array.from(new Set(types)).length;
      console.log(length);
      if (length == 1) {
        this.isType = true;
        let ids = val.map(item => {
          return item.id;
        });
        let clientType = Array.from(new Set(types));
        console.log(clientType);
        this.clientType = clientType;
        this.ids = ids.join(",");
      } else if (length == 2) {
        this.isType = false;
        let ids = val.map(item => {
          return item.id;
        });
        this.ids = "";
      }

      console.log(this.ids);
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {
      console.log(row);
      let ids = "";
      ids = this.ids;
      if (row) {
        ids = row.id;
        console.log(ids);
      }
      console.log(ids);
      delTags(ids).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success"
          });
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    updateSetTags() {
      let params = {};
      params.labelIds = this.currClassify.join(",");
      params.refIds = this.ids;
      console.log(params);
      editTags(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "批量打标签成功",
            type: "success"
          });
          this.dialogSetTags = false;
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          this.dialogSetTags = false;
        }
      });
    },
    handleUpdate(row, index, done) {
      let params = {};
      params.labelIds = this.currClassify.join(",");
      params.refIds = row.id;
      console.log(typeof row.id);
      editTags(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    }
  }
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
